<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <router-view ref="mainRoute" @closeChat2="closeChat2" @rerenderMainLayout="rerenderMainLayout"/>
    </transition>
<!--    <chatComponent2 ref="chat2" />-->
  </section>
</template>

<script>
// import chatComponent2 from '@/components/chat/chatComponent2.vue'
export default {
  name: 'AppMain',
  data() {
    return {
      isLoginPage: false
    }
  },
  mounted(){
    if(
            this.$route.name === 'invite-user' ||
            this.$route.name === 'confirm-email' ||
            this.$route.name === 'reset' ||
            this.$route.name === 'reset-password-confirm' ||
            this.$route.name === 'signup' ||
            this.$route.name === 'login' ||
            this.$route.name === 'mail-notification'||
            this.$route.name === 'meetings'){
      console.log(this.$route.name)
    }else{
      this.$store.dispatch('getCompanyLayout').then(resp => {
        console.log('companyUserId', resp)
        let data = {
          companyId: this.$route.query.companyId,
          companyUserId: resp.companyUserId
        }
        this.$socket.emit('companyChanged', data)
      })
    }
  },
  components: {
    // chatComponent2
  },
  methods:{
    rerenderMainLayout(){
      this.$emit('rerenderMainLayout')
    },
    closeChat2(){
      this.$emit('closeChat2')
    },
    // setShared2(projectId, state, taskId, companyId, sharedProjecttaskNoteId, companyName){
    //   console.log('projectId, state, taskId, companyId, sharedProjecttaskNoteId, companyName', projectId, state, taskId, companyId, sharedProjecttaskNoteId, companyName)
    //   this.$refs.mainRoute.setShared2(projectId, state, taskId, companyId, sharedProjecttaskNoteId, companyName)
    // },
    // REFRESH PROJECT PAGE AFTER ACCEPT SHARE TASK
    // PROJECT PAGE
    refreshSharedProject(){
      this.$refs.mainRoute.setProjectRowDataInput(Number(this.$route.query.projectId), 'first')
    },
    //SET PROJECT/BU/ENG ROW DATA
    setProjectRowDataInput(projectId){
      switch (this.$route.name){
        case 'projects':
          this.$refs.mainRoute.setProjectRowDataInput(projectId, 'first')
        break
        case 'engagements':
          this.$refs.mainRoute.setEngagementRowDataInput(projectId, 'first')
        break
        case 'business-units':
          this.$refs.mainRoute.setBusinessUnitRowDataInput(projectId, 'first')
        break
      }
    },
    //SET PROJECT/BU/ENG ROW DATA
    setProjectTaskRowDataInput(projectId, state, taskId){
      switch (this.$route.name){
        case 'projects':
          this.$refs.mainRoute.setProjectRowDataInput(projectId, state, taskId)
          break
        case 'engagements':
          this.$refs.mainRoute.setEngagementRowDataInput(projectId, state, taskId)
          break
        case 'business-units':
          this.$refs.mainRoute.setBusinessUnitRowDataInput(projectId, state, taskId)
        break
      }
    },
    //SET ACTIVE TAB (FIRST) PROJ/ENG/BU
    setActiveTabs(data){
      return new Promise (async (resolve, reject) =>{
        try {
          const tabSelect =  await this.$refs.mainRoute.setActiveTabs(data);
          resolve(tabSelect)
        } catch (err){
          console.log(err);
          reject(err)
        }
      })
    },
    selectCreatedTask(taskId){
      return new Promise (async (resolve, reject)=>{
        try {
          const selectedNode = await this.$refs.mainRoute.selectCreatedTaskNotification(taskId);
          resolve(selectedNode)
        } catch (err){
          console.log('err', err);
          reject(err)
        }
      })
    },
    //REFRESH TREE AFTER DELETE TIMER IN PROJ/ENG/BU
    refreshTreeAfterDeleteTimer(parentId, taskId){
      this.$refs.mainRoute.refreshTreeAfterDeleteTimer(parentId, taskId)
    },
    //REFRESH EXPENSE PAGE AFTER APPROVE OR REJECT FROM HEADER
    refreshExpensePageFromHeader(){
      this.$refs.mainRoute.refreshExpensePage()
    },
    //REFRESH CASH ADVANCE PAGE AFTER APPROVE OR REJECT FROM HEADER
    refreshCashAdvanceFromHeader(){
      this.$refs.mainRoute.refreshCashAdvancePage()
    },
    //REFRESH USER PAGE AFTER APPROVE OR REJECT FROM HEADER
    refreshUserExpensePageFromHeader(){
      this.$refs.mainRoute.refreshUserExpensePageFromHeader()
    },
    //SET SHARED TASK IN SHARED PROJECT PAGE
    setSharedTask(){
      this.$refs.mainRoute.setSharedTask()
    },
    //REFRESH PURCHASE TABLE
    refreshPurchase(){
      this.$refs.mainRoute.refreshPurchase()
    },
    //REFRESH VENDOR INVOICE TABLE
    refreshVendorInvoiceRequest(){
      this.$refs.mainRoute.refreshVendorInvoiceRequest()
    },
    setWorkDay(){
      this.$refs.mainRoute.handleCommand('changeWorkDay')
    }
  },
  watch:{
    '$route'(to, old) {
  //     if(to.name === 'invite-user' || to.name === 'confirm-email' || to.name === 'reset' || to.name === 'reset-password-confirm' || to.name === 'signup' || to.name === 'login' || old.name === 'companies'){
  //       if(this.$refs.chat2.list){
  //         this.$refs.chat2.list = false
  //       }
  //     }
  //     console.log('=====', to, old)
  if (!this.$store.getters.getActiveSubscription && !whiteListRoutes.includes(to.name)) {
    return this.$router.push(`/subscriptions?companyId=${to.query.companyId}`)
  }
    }
  }
}

const whiteListRoutes = ['subscriptions', 'invite-user', 'confirm-email', 'reset', 'reset-password-confirm', 'signup', 'login', 'companies']
</script>
<style lang="scss">
/*@import "../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";*/
/*@import "../../../node_modules/ag-grid-community/dist/styles/ag-theme-material.css";*/
/*@import "../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";*/

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  background: #f2f4f7;
  height: 100%;

  font-size: 16px;
  font-family: 'Assistant', Helvetica, Arial, sans-serif;
  a {
    color: #409EFF;
    text-decoration: none;
  }
}

// Input type number
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

// Font
button, input, .ag-theme-balham, .ag-header {
  font-family: 'Assistant', Helvetica, Arial, sans-serif !important;
}

// Tree col padding-left
// Material
.ag-theme-material .ag-ltr .ag-row-group-indent-1 {
  padding-left: 20px;
}
.ag-theme-material .ag-ltr .ag-row-group-indent-2 {
  padding-left: 40px;
}
.ag-theme-material .ag-ltr .ag-row-group-leaf-indent {
  margin-left: 0;
}

.ag-theme-material .ag-cell {
  border: none;
}

// Balham
.ag-theme-balham .ag-ltr .ag-row-group-indent-1 {
  padding-left: 20px;
}
.ag-theme-balham .ag-ltr .ag-row-group-indent-2 {
  padding-left: 40px;
}
.ag-theme-balham .ag-ltr .ag-row-group-leaf-indent {
  margin-left: 0;
}

.ag-theme-balham .ag-cell {
  border: none;
}

// Modal z-index
.el-select-dropdown, .el-picker-panel {
  z-index: 999999 !important;
}

// Modal text-align
.sweet-modal.is-alert .sweet-content {
  text-align: left !important;
}

// Modal width
.sweet-modal {
  max-width: 700px !important;
}

// Progress padding right
.el-timeline-item__wrapper {
  // padding-right: 20px !important;
}

// Wizard width
.vue-form-wizard .wizard-tab-content {
  padding: 30px 0 10px !important;
}
.vue-form-wizard .wizard-card-footer {
  padding: 0 !important;
}

// notifications
.el-notification {
  z-index: 99999 !important;
}

.disabled {
  color: red !important;
}
</style>

<style scoped lang="scss">
@import "../../../node_modules/@totalflow4/ag-grid-community/all-modules/dist/styles/ag-grid.css";
@import "../../../node_modules/@totalflow4/ag-grid-community/all-modules/dist/styles/ag-theme-balham.css";
  .app-main{
    width:100%;
  }
//GRID CSS START
@import url(https://fonts.googleapis.com/css?family=Roboto:700,400,300);

$spacing: 1rem;
$themeColor: #63B8FF;
$fullColor: #0fd641;
$lowColor: #e67112;
$backColor: #ddd;
$textShadow: rgba(black, 0.35) 1px 1px 1px;

* { box-sizing: border-box; }

/deep/.ag-header-row{
  color: #409EFF;
  font-size:14px;
  font-weight:500;
}
/deep/.ag-header-cell{
  overflow:visible;
}
/*/deep/.ag-theme-balham .ag-header-cell, .ag-theme-balham .ag-header-group-cell{*/
  /*padding-left:0;*/
/*}*/

/deep/.progress--circle {
  position: relative;
  display: inline-block;
  top: 6px;
  margin: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: $backColor;
  &:before {
    content: '';
    position: absolute;
    top: 3px;
    left: 3px;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background-color: white;
  }
  &:after {
    content: '';
    display: inline-block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: $themeColor;
  }
}

/deep/.ag-center-cols-viewport{
  width:100%;
}

/deep/.ag-header-container, .ag-floating-top-container, .ag-floating-bottom-container{
  width:100% !important;
}

/deep/.id-column{
  .ag-header-cell-label{
    justify-content:center;
  }
  padding-right:0;
}

/deep/.progress__number {
  position: absolute;
  top: 50%;
  width: 100%;
  line-height: 11px;
  margin-top: -0.38rem;
  text-align: center;
  font-size: 9px;
  color: #777;
}

/deep/.progress__number-mt {
  position: absolute;
  top: 55%;
  width: 100%;
  line-height: 11px;
  margin-top: -0.38rem;
  text-align: center;
  font-size: 10px;
  color: #777;
}


$step: 1;
$loops: round(100 / $step);
$increment: 360 / $loops;
$half: round($loops / 2);
@for $i from 0 through $loops {
  /deep/.progress--bar.progress--#{$i * $step}:after {
    width: $i * $step * 1%;
  }
  /deep/.progress--circle.progress--#{$i * $step}:after {
    @if $i < $half {
      $nextDeg: 90deg + ($increment * $i);
      background-image: linear-gradient(90deg, $backColor 50%, transparent 50%, transparent), linear-gradient($nextDeg, $themeColor 50%, $backColor 50%, $backColor);
    }
    @else {
      $nextDeg: -90deg + ($increment * ($i - $half));
      background-image: linear-gradient($nextDeg, $themeColor 50%, transparent 50%, transparent), linear-gradient(270deg, $themeColor 50%, $backColor 50%, $backColor);
    }
    @if $i == 100 {
      $nextDeg: -90deg + ($increment * ($i - $half));
      background-image: linear-gradient($nextDeg, $fullColor 50%, transparent 50%, transparent), linear-gradient(270deg, $fullColor 50%, $backColor 50%, $backColor);
    }
    @if $i < 25 {
      $nextDeg: 90deg + ($increment * $i);
      background-image: linear-gradient(90deg, $backColor 50%, transparent 50%, transparent), linear-gradient($nextDeg, $lowColor 50%, $backColor 50%, $backColor);
    }
  }
}

/deep/span.dayRender {
  background: #68a8e2;
  border-radius: 1.8em;
  -moz-border-radius: 1.8em;
  -webkit-border-radius: 1.8em;
  color: #ffffff;
  display: inline-block;
  font-weight: bold;
  line-height: 3.0em;
  margin-right: 5px;
  text-align: center;
  width: 28px;
  height: 28px;
  font-size: 10px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

/deep/span.typeRender {
  text-transform: uppercase;
  background: #DADADA;
  border-radius: 1.8em;
  -moz-border-radius: 1.8em;
  -webkit-border-radius: 1.8em;
  color: black;
  display: inline-block;
  font-weight: bold;
  line-height: 2.2em;
  margin-right: 5px;
  text-align: center;
  width: 28px;
  height:28px;
  font-size: 14px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

/deep/.imageRender {
  width: 28px;
  height: 28px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 20px;
}

/deep/.sharedRender {
  width: 28px;
  height: 28px;
  position:relative;
  margin-top: calc(50% - 12px);
  & #badge{
    z-index:1;
    position:absolute;
    top: -5px;
    right: -4px;
    & .el-badge__content{
      font-size:10px;
      height: 17px;
      padding: 0 5px;
    }
  }
}

/deep/.reoccuringRender{
  padding:2px 8px;
  background-color:#F4CAFF ;
  border-radius:4px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-weight:bold;
  line-height: 18px;
  color:#FF007A;
}

/deep/.txtRender {
  //position: absolute;
  //top: 50%;
  //transform: translateY(-50%);
  color: #0a98bf;
  font-size: 15px;
  position:relative;
}

/deep/span.typeNameRenderer {
  background: #4d7fab;
  border: 1.5px solid #2b577d;
  border-radius: 1.8em;
  -moz-border-radius: 1.8em;
  -webkit-border-radius: 1.8em;
  color: #ffffff;
  font-weight: 500;
  line-height: 3.0em;
  margin-right: 5px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  font-size: 10px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
/deep/span > .dayRemaningRender {
  background-image: url("../../assets/img/grid/days_bg.svg");
  background-repeat:no-repeat;
  background-size:100%;
  border-radius: 1.8em;
  -moz-border-radius: 1.8em;
  -webkit-border-radius: 1.8em;
  color: #ffffff;
  display: inline-block;
  font-weight: bold;
  line-height: 3.0em;
  margin-right: 5px;
  text-align: center;
  width: 28px;
  height: 28px;
  font-size: 10px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

/deep/.dayDoneRemaningRender {
  background-image: url("../../assets/img/grid/days_alert_bg.svg");
  background-repeat:no-repeat;
  background-size:100%;
  color: #ffffff;
  display: inline-block;
  font-weight: bold;
  line-height: 2.8em;
  margin-right: 5px;
  text-align: center;
  width: 28px;
  height: 28px;
  font-size: 10px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

/deep/.custom-tooltip {
  background-color: #303133;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 8px 10px;
  position: absolute;
  pointer-events: none;
  display: inline-block;
  z-index: 1 !important;
  overflow: unset !important;
  margin-left: -20px;
}

/*/deep/.name-cell > span{*/
/*.ag-cell-value{*/
/*position:relative;*/
/*&::after{*/
/*content:'';*/
/*position:absolute;*/
/*background: url("../components/ag-grid-components/assets/dot.svg");*/
/*background-position: left center;*/
/*background-repeat: repeat-x;*/
/*}*/
/*}*/
/*}*/

/deep/.ag-row-group-indent-1{
  background-image: url("../../components/ag-grid-components/assets/dot1.svg");
  background-position: left center;
  background-repeat: no-repeat;
}

/deep/.ag-row-group-indent-2{
  background-image: url("../../components/ag-grid-components/assets/dot2.svg");
  background-position: left center;
  background-repeat: no-repeat;
}

/deep/.ag-row-group-indent-3{
  background-image: url("../../components/ag-grid-components/assets/dot3.svg");
  background-position: left center;
  background-repeat: no-repeat;
  padding-left:55px !important;
}

/deep/.ag-row-group-indent-4{
  background-image: url("../../components/ag-grid-components/assets/dot4.svg");
  background-position: left center;
  background-repeat: no-repeat;
  padding-left:74px !important;
}

/deep/.ag-row-group-indent-5{
  background-image: url("../../components/ag-grid-components/assets/dot5.svg");
  background-position: left center;
  background-repeat: no-repeat;
  padding-left:87px !important;
}

/deep/.ag-row-group-indent-6{
  background-image: url("../../components/ag-grid-components/assets/dot6.svg");
  background-position: left center;
  background-repeat: no-repeat;
  padding-left:107px !important;
}

/deep/.ag-row-group-indent-7{
  background-image: url("../../components/ag-grid-components/assets/dot7.svg");
  background-position: left center;
  background-repeat: no-repeat;
  padding-left:125px !important;
}

/deep/.ag-row-group-indent-8{
  background-image: url("../../components/ag-grid-components/assets/dot8.svg");
  background-position: left center;
  background-repeat: no-repeat;
  padding-left:145px !important;
}

/deep/.ag-row-group-indent-9{
  background-image: url("../../components/ag-grid-components/assets/dot9.svg");
  background-position: left center;
  background-repeat: no-repeat;
  padding-left:160px !important;
}

/deep/.ag-row-group-indent-10{
  background-image: url("../../components/ag-grid-components/assets/dot10.svg");
  background-position: left center;
  background-repeat: no-repeat;
  padding-left:177px !important;
}

/deep/.ag-row-group-indent-11{
  background-image: url("../../components/ag-grid-components/assets/dot11.svg");
  background-position: left center;
  background-repeat: no-repeat;
  padding-left:35px !important;
}

/deep/.ag-row-group-indent-12{
  background-image: url("../../components/ag-grid-components/assets/dot12.svg");
  background-position: left center;
  background-repeat: no-repeat;
  padding-left:55px !important;
}

/deep/.ag-row-group-indent-13{
  background-image: url("../../components/ag-grid-components/assets/dot13.svg");
  background-position: left center;
  background-repeat: no-repeat;
  padding-left:74px !important;
}

/deep/.ag-row-group-indent-14{
  background-image: url("../../components/ag-grid-components/assets/dot14.svg");
  background-position: left center;
  background-repeat: no-repeat;
  padding-left:87px !important;
}

/deep/.ag-row-group-indent-15{
  background-image: url("../../components/ag-grid-components/assets/dot15.svg");
  background-position: left center;
  background-repeat: no-repeat;
  padding-left:107px !important;
}

/deep/.ag-row-group-indent-16{
  background-image: url("../../components/ag-grid-components/assets/dot16.svg");
  background-position: left center;
  background-repeat: no-repeat;
  padding-left:125px !important;
}

/deep/.ag-row-group-indent-17{
  background-image: url("../../components/ag-grid-components/assets/dot17.svg");
  background-position: left center;
  background-repeat: no-repeat;
  padding-left:145px !important;
}

/deep/.ag-row-group-indent-18{
  background-image: url("../../components/ag-grid-components/assets/dot18.svg");
  background-position: left center;
  background-repeat: no-repeat;
  padding-left:160px !important;
}

/deep/.ag-row-group-indent-19{
  background-image: url("../../components/ag-grid-components/assets/dot19.svg");
  background-position: left center;
  background-repeat: no-repeat;
  padding-left:177px !important;
}

/deep/.ag-row-group-indent-20{
  background-image: url("../../components/ag-grid-components/assets/dot20.svg");
  background-position: left center;
  background-repeat: no-repeat;
  padding-left:192px !important;
}

/deep/.custom-tooltip.ag-tooltip-hiding {
  opacity: 0;
}
/deep/.ag-floating-filter-body{
  position:relative;
  &:before{
    font-family: "Font Awesome 5 Free";
    font-weight: 700;
    content: '\f002';
    width:10px;
    height:10px;
    position:absolute;
    left:-17px;
  }
}
/deep/.ag-floating-filter-body input{
  border-bottom: 2px solid #DCDFE6;
  border-left: none;
  border-right: none;
  border-top: none;
  background-color: transparent;
}

/deep/.ag-floating-filter-body input :hover{
  border-bottom: 2px solid #409EFF;
}

/deep/.ag-theme-balham .ag-root{
  border: 0;
}
/deep/.ag-theme-balham .ag-header-cell:not(.ag-header-group-cell-no-group), .ag-theme-balham .ag-header-group-cell:not(.ag-header-group-cell-no-group){
  border: 0;
}
/deep/.ag-theme-balham .ag-row:not(.ag-row-first){
  border-width: 0 0 0;
}
/deep/.ag-floating-filter-button{
  display:none;
}
/deep/.ag-theme-balham .ag-header{
  background-color: #f6fbfe !important;
}
//GRID CSS END
</style>
